import { RANDOM_ORCHESTRATOR } from '../../../../utils/config/environment';
import { determineCrosschainAddresses } from '../../../../utils/validation/order-validation';
export async function getMultiNetworkPrice({ PKP, tokenInOrders, tokenOutOrders, fromSlippage, baseUrl, permitBatchDetails, permitSignatures, priorityFee, }) {
    try {
        const url = baseUrl + '/price/multi-chain';
        console.log(`------------------- url is`, url, `-------------------`);
        let body;
        if (url === null || url === void 0 ? void 0 : url.includes('multi-chain')) {
            const tokenInOrder = tokenInOrders[0];
            const tokenOutOrder = tokenOutOrders[0];
            const networkIn = tokenInOrder.network;
            const networkOut = tokenOutOrder.network;
            const tokenIn = tokenInOrder.tokenIn;
            const tokenOut = tokenOutOrder.tokenOut;
            const amountIn = tokenInOrder.amountIn;
            const slippage = fromSlippage;
            const permit = {
                signature: permitSignatures[0],
                permitBatch: permitBatchDetails[0],
            };
            const orchestrator = RANDOM_ORCHESTRATOR();
            const { from, recipient, srcOrchestrator, destOrchestrator } = determineCrosschainAddresses(networkIn, networkOut, PKP, orchestrator);
            const maxAccounts = 22;
            const authority = {
                networkInAddress: srcOrchestrator,
                networkOutAddress: destOrchestrator,
            };
            body = JSON.stringify({
                networkIn,
                networkOut,
                tokenIn,
                tokenOut,
                amountIn,
                slippage,
                from,
                recipient,
                permit,
                priorityFee,
            });
        }
        else {
            const networkIn = tokenInOrders[0].network;
            const networkOut = tokenOutOrders[0].network;
            const tokenIn = tokenInOrders[0].tokenIn;
            const tokenOut = tokenOutOrders[0].tokenOut;
            const amountIn = tokenInOrders[0].amountIn;
            const slippage = fromSlippage;
            const permit = {
                signature: permitSignatures[0],
                permitBatch: permitBatchDetails[0],
            };
            body = JSON.stringify({
                networkIn,
                networkOut,
                tokenIn,
                tokenOut,
                amountIn,
                slippage,
                PKP,
                orchestrate: false,
                permit,
                priorityFee,
            });
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body,
        });
        const data = await response.json();
        console.log('QUOTE 2 MultiNetworkPrice', data);
        if (data.error) {
            throw new Error(data.error);
        }
        return data;
    }
    catch (error) {
        console.error('Error fetching multi network price', error);
        return { error: error.message };
    }
}
